import Feathers from './feathers'

class User extends Feathers {
    login (data) {
        return this.request({
            url: `${ this.base }/user/login`,
            data,
            method: 'post'
        })
    }
    getloginurl()
    {
        return this.request({
            url: `${ this.base }unit/service/loginuri?defaulturl=/&returnUrl=${encodeURIComponent(window.location.href)}&bindcardUrl=${encodeURIComponent(`${window.location.origin}/account/mylibrary/default.html?templatename=childlibrary&virtualpath=${sessionStorage.getItem("virtualPath")}&pagename=userSetting`)}`

        })
    }
    logout () {
        const url = `${ this.base }user/logout`
        return this.request({
            url
        })
    }

    register (data) {
        return this.request({
            url: `${ this.base }user/register`,
            data,
            method: 'post'
        })
    }

    changePassword (data) {
        return this.request({
            url: `${ this.base }user/ChangePassword`,
            data,
            method: 'post'
        })
    }

    bindCard (data) {
        return this.request({
            url: `${ this.base }Authorization/ReaderCard/Bind`,
            data,
            method: 'post'
        })
    }

    isInUserCollection (resourceid) {
        const url = `${ this.base }user/favorite/id?resourceid=${ resourceid }`
        return this.request({
            url
        })
    }

    addToCollection (data) {
        return this.request({
            url: `${ this.base }user/favorite/add`,
            data,
            method: 'post'
        })
    }

    removeFromCollection (data) {
        return this.request({
            url: `${ this.base }user/favorite/remove`,
            data,
            method: 'post'
        })
    }

    getCollectionLists (pageindex) {
        const url = `${ this.base }magazine/article/favorite?resourcekind=100&pagesize=20&pageindex=${ pageindex }`
        return this.request({
            url
        })
    }

    isInUserBookCase (query) {
        const { resourceid, year, issue, date, kind } = query
        let url = `${ this.base }user/favorite/id?resourceid=${ resourceid }`
        if(date)
        {
           url = `${ this.base }user/favorite/id?resourceid=${
             resourceid }&date=${ date }&kind=${ kind }` 
        }
        if (year) {
            url = `${ this.base }user/favorite/id?resourceid=${
            resourceid }&year=${ year }&issue=${ issue }`
        }
        return this.request({
            url
        })
    }

    addToBookCase (data) {
        return this.request({
            url: `${ this.base }user/favorite/add`,
            data,
            method: 'post'
        })
    }

    removeFromBookCase (data) {
        return this.request({
            url: `${ this.base }user/favorite/remove`,
            data,
            method: 'post'
        })
    }

    getBookCaseLists (resourceName, pageindex = 1) {
        const url = `${ this.base }${ resourceName }/favorite?pagesize=20&pageindex=${ pageindex }`
        return this.request({
            url
        })
    }

    statisticalgetdata(url,param,type='POST',contenttype='application/json')
    {
        let rest = fetch(url, {
                body: JSON.stringify(param), 
                method: type, 
                headers: {
                  'content-type': contenttype
                }
        }).then(function(response) {
                return response.json();
        }).then(function(myJson) {      
                console.log(myJson);
        }).catch(err=>{
          console.error;
        });
        
    }
    getuserip()
    {
        const url = `${ this.base }system/userip`
        return this.request({
            url
        })
    }
    getuserisauthorized()
    {
        const url = `${ this.base }unit/service/authorized`
        return this.request({
            url
        })
    }
    getallresourecelist()
    {
        const url = `${ this.base }category/resource/list`
        return this.request({
            url
        })
    }
}

export default User
